import React from 'react';
import styles from './errorBoundary.css';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        console.error(error);
        return { hasError: true };
    }

    render() {
        // if (this.state.hasError) {
        //     return(
        //     <div className={ styles.wrap}>
        //         <h1>An error has occurred!. Sorry for the inconvenience!.</h1>
        //     </div>);
        // }
        return this.props.children;
    }
}

export default ErrorBoundary;